import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import WidgetsList from './WidgetsList'

const SelectWidgetTypeModal = props => {
  return (
    <ControlledModal width="64rem" fullScreen {...props}>
      <PermissionChecker permission={'setupScreen'}>
        <ModalHeader />

        <LineSeparator weight={2} />
        <Separator weight={6} />

        <WidgetsList />
      </PermissionChecker>
    </ControlledModal>
  )
}

export default SelectWidgetTypeModal
